import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { FitLayout } from "@/components/fitLayout";
import { Policy, PolicyType } from "@/features/policy";
import {useI18N} from "@/context/I18NContext";
import { getMessage } from "@/utils/I18nUtils";

const getLegalPageType : (type : string) => PolicyType = (type : string) => {
    if(type == 'legal_notice'){
        return PolicyType.LEGAL_NOTICE;
    }

    if(type == 'privacity'){
        return PolicyType.PRIVACITY_POLICY;
    }

    if(type == 'service_conditions'){
        return PolicyType.SERVICE_CONDITIONS;
    }

    return PolicyType.COOKIES_POLICY;
}

export default function LegalPage(props: any) {
    const {
        type
    } = props;

   const {t} = useI18N();

  return (
    <FitLayout title={t(type)}>
        <Policy type={getLegalPageType(type)} data={{}}/>
    </FitLayout>
  );
}

export const getServerSideProps = async (context: any) => {
  const { locale, query } = context;
  const type = query.type;
  const translations = await serverSideTranslations(locale, ["common"]);

  return {
    props: {
      ...translations,
      type,
      metadata: {
        title: getMessage(translations, locale, `${type}`),
        description: getMessage(translations, locale, `${type}`),
      },
    },
  };
};
